const c=(e,o)=>e.filter(r=>r.anchorType===o);export{c as filterAnchorableBlocks};
//# sourceMappingURL=anchorUtils.js.map
